import { FC } from 'react';

import { useOrderProductIssueModal } from 'src/stores/useOrderProductIssueModal';

import OrderProductIssueModal from './OrderProductIssueModal';

/**
 * 전역 모달 렌더러
 * App.tsx 또는 Layout에서 한 번만 렌더링하면 됩니다.
 */
const OrderProductIssueModalRenderer: FC = () => {
  const { state, close } = useOrderProductIssueModal();

  if (!state.open || !state.order || !state.store || !state.product) {
    return null;
  }

  return (
    <OrderProductIssueModal
      open={state.open}
      onClose={close}
      order={state.order}
      store={state.store}
      product={state.product}
      changeType={state.changeType}
      newVolume={state.newVolume}
      source={state.source}
    />
  );
};

export default OrderProductIssueModalRenderer;
